import React from "react";
import PropTypes from "prop-types";

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(`${value}T12:00:00`);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString("pl-PL");
};

const ClassLessonHistoryModal = ({ open, loading, error, items, nextCursor, onClose, onLoadMore }) => {
  if (!open) return null;
  return (
    <div className="attendance-page__modal-placeholder" role="dialog" aria-modal="true" aria-labelledby="lesson-history-title">
      <div className="attendance-page__modal-card attendance-page__history-modal">
        <div className="attendance-page__lesson-summary-heading">
          <h3 id="lesson-history-title" className="attendance-page__modal-title">Poprzednie tematy tej grupy</h3>
          <button type="button" className="btn manage-button manage-teal-button" onClick={onClose}>Zamknij</button>
        </div>
        {error && <div className="alert alert-danger" role="alert">{error}</div>}
        {!loading && !error && items.length === 0 && <p>Brak wcześniejszych lekcji do wyświetlenia.</p>}
        <div className="attendance-page__history-list">
          {items.map(item => (
            <article key={item.lessonId} className="attendance-page__history-item">
              <div className="attendance-page__history-meta">
                <strong>{formatDate(item.date)}{item.startTime ? `, ${item.startTime}` : ""}</strong>
                {item.teacherName && <span>{item.teacherName}</span>}
              </div>
              {item.status === "cancelled" && <p>Lekcja odwołana</p>}
              {item.status === "noSummary" && <p>Nie dodano podsumowania.</p>}
              {item.status === "summarized" && <p>{item.lessonSummary}</p>}
            </article>
          ))}
        </div>
        {loading && <p role="status">Ładowanie poprzednich tematów...</p>}
        {nextCursor && !loading && (
          <button type="button" className="btn manage-button manage-teal-button" onClick={onLoadMore}>Pokaż starsze</button>
        )}
      </div>
    </div>
  );
};

ClassLessonHistoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    lessonId: PropTypes.string.isRequired,
    date: PropTypes.string,
    startTime: PropTypes.string,
    teacherName: PropTypes.string,
    status: PropTypes.string.isRequired,
    lessonSummary: PropTypes.string,
  })).isRequired,
  nextCursor: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
};

ClassLessonHistoryModal.defaultProps = { error: "", nextCursor: null };

export default ClassLessonHistoryModal;
